// export default AudioContext || webkitAudioContext;
export default window.AudioContext || window.webkitAudioContext;



// WEBPACK FOOTER //
// ./src/utils/react-audio-recorder-fixed/AudioContext.js